<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uF7viD/tc-custom/9780544273306.jpg?1734279524357" alt="This image is the cover for the book After Birth"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">After Birth
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A fierce novel about the postpartum experience filled with “dark humor and brutal honesty” (<i>People</i>)<i>.</i></b><br/>  <br/> A year has passed since Ari gave birth to Walker, though it went so badly awry she has trouble calling it “birth” and she still can’t locate herself in her altered universe. Amid the strange, disjointed rhythms of her days and nights, and another impending winter in upstate New York, Ari is a tree without roots, struggling to keep her branches aloft.<br/>  <br/> When Mina, a one-time cult indie musician—older, self-contained, alone, and nine months pregnant—moves to town, Ari sees the possibility of a new friend. And despite her unfortunate habit of generally mistrusting other females, they soon become comrades-in-arms . . .<br/>  <br/> With piercing insight about the isolation and unrealistic expectations suffered by new mothers in our society, <i>After Birth </i>is about pregnancy and childbirth that is “vicious, hilarious, and above all real” (<i>The </i><i>New York Times Book Review</i>).<br/>  <br/> “[A] scaldingly and exhilaratingly honest account of new motherhood, emotional exile, and the complex romance of female friendship.” —Karen Russell, author of<i> Swamplandia!</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elisa Albert
      </h2>
      
      <p class="authorDescription body article">Elisa Albert, author of <I>The Book of Dahlia</I> and a collection of short stories, has written for NPR, <I>Tin House</I>, <I>Commentary</I>,<I>&#160;</I><I>Salon</I>, and the<I> Rumpus.</I> She grew up in Los Angeles and now lives in upstate New&#160;York with her family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cdbf6ab2